import React from "react";

export interface IProps {
  type: "windows" | "mac" | "andriod";
}
const OsIcon: React.FC<IProps> = ({ type }) => {
  return type === "windows" ? (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.0733 23.017L6.3999 23.017L6.3999 6.40039L23.0733 6.40039L23.0733 23.017Z"
        fill="#717985"
      />
      <path
        d="M41.4826 23.017L24.8095 23.017L24.8095 6.40039L41.4826 6.40039L41.4826 23.017Z"
        fill="#717985"
      />
      <path
        d="M23.0727 41.37L6.39991 41.37L6.3999 24.7537L23.0727 24.7537L23.0727 41.37Z"
        fill="#717985"
      />
      <path
        d="M41.4826 41.37L24.8095 41.37L24.8095 24.7537L41.4826 24.7537L41.4826 41.37Z"
        fill="#717985"
      />
    </svg>
  ) : type === "mac" ? (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.138 25.2228C36.1174 21.7062 37.7107 19.0559 40.9282 17.1017C39.1286 14.5236 36.4061 13.1056 32.8174 12.8323C29.4194 12.5642 25.7018 14.8123 24.3405 14.8123C22.9019 14.8123 19.6122 12.9252 17.0238 12.9252C11.6819 13.0077 6.00488 17.1842 6.00488 25.6817C6.00489 28.1928 6.46379 30.7864 7.3816 33.4573C8.60879 36.9739 13.0329 45.59 17.6477 45.4508C20.0608 45.3941 21.7675 43.7389 24.9077 43.7389C27.955 43.7389 29.5329 45.4508 32.2244 45.4508C36.8805 45.3837 40.8818 37.5514 42.0471 34.0245C35.8029 31.0803 36.138 25.4033 36.138 25.2228ZM30.7188 9.49625C33.333 6.39218 33.0958 3.56656 33.0185 2.55078C30.7085 2.68484 28.0375 4.12344 26.5164 5.89203C24.8407 7.78953 23.8558 10.1356 24.0672 12.7808C26.5629 12.9716 28.8419 11.6877 30.7188 9.49625Z"
        fill="#717985"
      />
    </svg>
  ) : (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32.5447 30.494L26.8049 24.698L7.62466 44.1759C7.85579 44.1057 8.10108 43.9992 8.36304 43.8539C8.55924 43.7455 9.03651 43.4823 9.73802 43.0954L9.77979 43.0724C13.7275 40.8952 24.5664 34.9173 32.5447 30.494Z"
        fill="#717985"
      />
      <path
        d="M33.6349 29.8895C34.3733 29.48 35.0809 29.0871 35.7494 28.7159C36.2232 28.4528 36.6773 28.2006 37.1089 27.9611L37.1112 27.9599C39.7921 26.4723 41.5992 25.4697 41.8159 25.3609C42.8173 24.8231 43.8521 23.4002 41.8159 22.2951C41.1854 21.9618 37.9039 20.1448 33.6302 17.7667L27.6469 23.8429L33.6349 29.8895Z"
        fill="#717985"
      />
      <path
        d="M32.5203 17.1836C28.9747 15.231 9.64326 4.58599 8.3627 3.89835C8.11942 3.75234 7.86027 3.65411 7.5996 3.59961L26.8024 22.9902L32.5203 17.1836Z"
        fill="#717985"
      />
      <path
        d="M6.13165 3.82268L25.9604 23.8453L6.05761 44.057C5.49484 43.6741 5.2002 42.8732 5.2002 41.8618L5.2002 5.98212C5.2002 4.86368 5.59075 4.1755 6.13165 3.82268Z"
        fill="#717985"
      />
    </svg>
  );
};

export default OsIcon;
